import { render, staticRenderFns } from "./DormakabaComponentSpotWidgetControl.vue?vue&type=template&id=389f9318&lang=pug&"
import script from "./DormakabaComponentSpotWidgetControl.vue?vue&type=script&lang=ts&"
export * from "./DormakabaComponentSpotWidgetControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports